import { request } from "@umijs/max";

/** 获取目录数据 */
export async function getFolderList(params: any) {
    return request<any>("/etmf/v1/biz/folder/list", {
        method: "GET",
        params: {
            folderId: params.folder_id,
            ...params,
        },
    });
}

/** 获取目录数据 */
export async function getFolderPath(fileOrFolderId: string) {
    return request<any>("/etmf/v1/biz/folder/getFolderPath", {
        method: "GET",
        params: {
            fileOrFolderId: fileOrFolderId,
        },
    });
}

/** 获取文件痕迹 */
export async function getFileTrace(params: {
    file_id: string;
    opt_type?: number;
}) {
    return request<API.Result<API.FileTrace[]>>(
        "/etmf/v1/biz/file/file_history",
        {
            method: "GET",
            params,
        }
    );
}

/** 获取文件痕迹 */
export async function getFileQuestion(params: {
    file_id: string;
    opt_type?: number;
}) {
    return request<API.Result<API.FileQuestion[]>>(
        "/etmf/v1/biz/question/list_q",
        {
            method: "GET",
            params,
        }
    );
}

/** 获取文件痕迹 */
export async function getFileApprove(params: { fileId: string }) {
    return request<API.FileApproveModel[]>("/etmf/v1/biz/file/approve", {
        method: "GET",
        params,
    });
}

/** 获取文件详情 */
export async function getFileDetail(params: { fileId: string }) {
    return request<API.Result<API.FileDetail>>("/etmf/v1/biz/file/get", {
        method: "GET",
        params: {
            id: params.fileId,
        },
    });
}

/** 获取文件详情 */
export async function getFilePlaceholder(params: { folderId: string }) {
    return request<API.Result<API.FilePlaceholder[]>>(
        "/etmf/v1/biz/folder/file_placeholder_list",
        {
            method: "GET",
            params,
        }
    );
}

/** 获取授权目录树列表 */
export async function grantFolderList(params: { folderId: string }) {
    return request<API.Result<API.GrantFolder[]>>("/etmf/v1/biz/folder/grant", {
        method: "GET",
        params,
    });
}

/** 获取授权目录树列表 */
export async function grantAllFolderList(params: {
    projectId?: string;
    folderId?: string;
}) {
    return request<API.Result<API.GrantFolder[]>>(
        "/etmf/v1/biz/folder/grant/all",
        {
            method: "GET",
            params,
        }
    );
}

export async function folderDownload(data: any) {
    return request<API.Result<any>>("/etmf/v1/biz/folder/pack_down", {
        method: "POST",
        data,
    });
}

export async function folderExport(params: any) {
    return request<API.Result<any>>("/etmf/v1/biz/folder/export_report", {
        method: "GET",
        params,
    });
}

export async function getProjectTemplate(params: any) {
    return request<API.Result<string>>("/etmf/v1/biz/folder/template", {
        method: "GET",
        params,
    });
}

export async function folderUpdate(data: any) {
    return request<API.Result<any>>("/etmf/v1/biz/folder/upd", {
        method: "POST",
        data,
    });
}

export async function fileDownload(data: any) {
    return request<API.Result<any>>("/etmf/v1/biz/file/batch_download", {
        method: "POST",
        data,
    });
}

export async function folderRename(data: any) {
    return request<API.Result<any>>("/etmf/v1/biz/folder/upd", {
        method: "POST",
        data,
    });
}

export async function getFolderOption(params: any) {
    return request<API.Result<API.Option[]>>("/etmf/v1/biz/folder/option", {
        method: "GET",
        params,
    });
}

// 查询模板目录树
export async function getTemplateFolderTreeOption(params: any) {
    return request<API.Result<API.Option[]>>(
        "/etmf/v1/biz/folder/template/tree",
        {
            method: "GET",
            params,
        }
    );
}

//恢复目录
export async function folderSetting(data: any) {
    return request<API.Result<any>>("/etmf/v1/biz/folder/importChecked", {
        method: "POST",
        data,
    });
}

//恢复目录
export async function getFolderFileCountByCode(params: any) {
    return request<API.Result<any>>("/etmf/v1/biz/folder/file/count", {
        method: "GET",
        params,
    });
}

// 根据文件夹ID和文件名查询可自动激活的占位符
export async function getAutoActivePlaceholder(
    folderId: string,
    data: string[]
) {
    return request<API.Result<API.AutoActivePlaceholderItem[]>>(
        `/etmf/v1/biz/file/placeholder/auto-active/list?folderId=${folderId}`,
        {
            method: "POST",
            data,
        }
    );
}

// 激活文件
export async function autoActiveFile(data: any) {
    return request<API.Result<any>>(
        "/etmf/v1/biz/file/placeholder/auto-active",
        {
            method: "POST",
            data,
        }
    );
}
